import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {MessageService} from "primeng/components/common/messageservice";
import {ActivatedRoute, Router} from "@angular/router";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {PromocionesService} from "../../../core/promociones/promociones.service";
import {CustomValidators} from "../../../core/validators/custom-validators";
import * as moment from "moment";
import {DIMENSION, Promociones} from "../../promociones/promociones";
import {InfoModalComponent} from "../../promociones/info-modal.component";
import {SetPrincipalModalComponent} from "../../promociones/set-principal-modal-component";
import {GanalottodoPromotionComponent} from "../../promociones/ganalottodo/admin-promotion/ganalottodo-promotion.component";
import {BannerService} from "../../../core/banner/banner.service";
import {MessageResponse} from "../../../core/banner/message-response";
import {NewMessageRequest} from "../../../core/banner/new-message-request";

@Component({
  selector: 'app-admin-banners',
  templateUrl: './admin-banners.component.html',
  styleUrls: ['./admin-banners.component.scss']
})
export class AdminBannersComponent implements OnInit {
  messageForm: FormGroup;
  messageKey;
  messageActive = true;
  isReadOnly = false;
  isLoading = false;
  message: MessageResponse;

  constructor(
    private formBuilder: FormBuilder,
    public bannerService: BannerService,
    private _route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private messageService: MessageService
  ) {
  }


  ngOnInit() {
    this.initForm(null);
    this._route.params.subscribe(params => {
      this.messageKey = params['message'];
      if (params['message'] !== 'new') {
        this.retrieveMessage(this.messageKey);
      } else {
        this.initForm(null);
        // this.promotion.principal = false;
      }
    });

  }


  initForm(messageData) {
    this.messageForm = this.formBuilder.group({
      messageName: [messageData !== null ? messageData.name : '', Validators.required],
      messageStartDate: [messageData !== null ? this.builtObjectDate(messageData.startDate) : '', Validators.required],
      messageEndDate: [messageData !== null ? this.builtObjectDate(messageData.endDate) : '', Validators.required],
      messageContent: [messageData !== null ? messageData.message : '', Validators.required]
    });

    // this.messageActive = messageData.active;
    // this.messageForm.patchValue({
    //   endTime: messageData ? GanalottodoPromotionComponent.parseTime(messageData.endTime) : GanalottodoPromotionComponent.messageData('21:15')
    // });

  }

  onSubmit() {
    this.saveMessage();
  }

  activeMessage() {
    this.messageActive = !this.messageActive;
  }


  protected retrieveMessage(messageKey) {
    this.isLoading = true;
    this.bannerService.getMessageOfBannerByMessageKey(messageKey)
      .finally(() => this.isLoading = false)
      .subscribe(
        success => {
          this.message = success;
          this.initForm(success);
          this.messageActive = this.message.active;
          console.log('mostramos el mensaje: ', success);
        },
        error => {
          this.messageService.clear();
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error
          });
        });
  }

  builtObjectDate(valueAsLong): any {
    const date = new Date(+valueAsLong);
    const dateResult = {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    };
    return dateResult;
  }

  private saveMessage() {
    this.isLoading = true;
    const newMessage = this.builtMessageRequest();
    this.bannerService.saveMessageOfBanner(newMessage).subscribe(
      (response) => {
        this.isLoading = false;
        this.router.navigate(['/ganalottodo/banners']);
        this.messageService.clear();
        this.messageService.add({
          severity: 'success',
          summary: '',
          detail: 'Se agrego mensaje correctamente'
        });
        console.log('Se agrego mensaje correctamente');
        console.log(response);
      },
      (error) => {
        this.isLoading = false;
        console.log('Error al guardar mensaje');
        console.log(error);
        this.messageService.clear();
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al guardar mensaje'
        });
      }
    );

  }
  updateMessage() {
    this.isLoading = true;
    const message = this.builtMessageRequest();
    this.bannerService.updateMessageOfBanner(message, this.messageKey).subscribe(
      (response) => {
        this.isLoading = false;
        this.router.navigate(['/ganalottodo/banners']);
        this.messageService.clear();
        this.messageService.add({
          severity: 'success',
          summary: '',
          detail: 'Se actualizo mensaje correctamente'
        });
        console.log('Se actualizo mensaje correctamente');
        console.log(response);
      },
      error => {
        this.isLoading = false;
        console.log('Error al guardar mensaje');
        console.log(error);
        this.messageService.clear();
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al actualizar mensaje'
        });
      }
    );
  }

  private builtMessageRequest(): NewMessageRequest {
    const message = new NewMessageRequest(
      this.messageForm.value.messageName,
      this.messageForm.value.messageContent,
      this.builtDate(this.messageForm.value.messageStartDate),
      this.builtDate(this.messageForm.value.messageEndDate),
      this.messageActive);
    return message;
  }

  builtDate(dateAsObject): Date {
    const date = new Date(dateAsObject.year, dateAsObject.month - 1, dateAsObject.day);
    console.log(date);
    return date;
  }

  // fillModel(): FormData {
  //   // let formData = new FormData($('<form></form>'));
  //   // new FormData($('<form></form>'));
  //   // console.log(this.promotionForm.get('file1').value);
  //   // formData.append("name", this.promotionForm.get('promotionName').value);
  //   // formData.append("description", this.promotionForm.get('promotionDescription').value);
  //   // formData.append("typePromotion", this.promotionForm.get('promotionType').value);
  //   // formData.append("startTime", moment(this.promotionForm.get('startTime').value).format('HH:mm:ss'));
  //   // formData.append("endTime", moment(this.promotionForm.get('endTime').value).format('HH:mm:ss'));
  //   // formData.append("active", this.promotionActive + '');
  //   // formData.append("principal", this.promotion.principal + '');
  //   //
  //   // formData.append("emailFounder", this.promotionForm.get('emailFounder').value);
  //   // formData.append("promotionAmount", this.promotionForm.get('promotionAmount').value);
  //   //
  //   // _.forEach(this.promotionList, component => {
  //   //   formData.append("templateName", component.templateName);
  //   //   formData.append("imageName", component.imageName);
  //   //   formData.append("imagePosition", component.imagePosition);
  //   //   formData.append("resources", component.resources);
  //   // });
  //   // return formData;
  // }


  // private static parseTime(time: string): Date {
  //   //
  //    const momentDate = moment();
  //   // let data = time.split(':');
  //   //
  //   // momentDate.hours(parseInt(data[0]));
  //   // momentDate.minutes(parseInt(data[1]));
  //   // momentDate.seconds(0);
  //   // momentDate.milliseconds(0);
  //   //
  //    return momentDate.toDate();
  // }

  goBack() {
    this.router.navigate(['/ganalottodo/banners']);
  }


}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/banners/admin-banners/admin-banners.component.ts